import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useRecordContext } from 'react-admin';
import { db } from '../../firebase';

export const CountryName = () => {
  const record = useRecordContext();
  const [countryName, setCountryName] = useState<string | null>(null);

  useEffect(() => {
    if (!record || typeof record.id !== 'string') return;
  
    const fetchCountry = async () => {
      try {
        const userDoc = await getDoc(doc(db, 'users', String(record.id)));
        
        const userData = userDoc.data();

        if (!userData) {
          console.warn('No data found in user document');
          return;
        }
        
        if (!userData.country) return;
  
        const countryRef = userData.country;
        const countryDoc = await getDoc(countryRef);

        if (countryDoc.exists()) {
          const countryData = countryDoc.data() as { country_name?: string };
          setCountryName(countryData.country_name || 'Unknown');
        }
      } catch (err) {
        console.error('Error loading country reference:', err);
      }
    };
  
    fetchCountry();
  }, [record?.id, record]);

  return <span>{countryName || 'Loading country...'}</span>;
};